<template>
    <b-card title="Claimants without Email">
        <b-table :items="items" :fields="fields">
            <template v-slot:cell(link_to_client)="data">
                <a :href="'/business/clients/' + data.item.id" class="btn btn-secondary">
                    <i class="fa fa-edit"></i>
                </a>
            </template>
        </b-table>
    </b-card>
</template>

<script>
    export default {
        props: ['clients'],
        
        data() {
            return{
                items: this.clients,
                fields: [
                    'name',
                    'link_to_client'
                ]
            }
        }
    }
</script>